/**
* 纠纷添加
*/
<template>
    <div>
        <van-nav-bar placeholder title="新增纠纷" left-text="返回" left-arrow @click-left="onClickLeft()">
            <template #right>
            </template>
        </van-nav-bar>
        <van-form @submit="onSubmit">
            <van-field
                readonly
                clickable
                required
                v-model="dataParams.disputeName"
                label="纠纷类型"
                class="select"
                placeholder="请选择"
                @click="showPickerView(1)"
                :rules="[{ required: true, message: '纠纷类型不能为空!' }]"
            />
            <van-field
                    readonly
                    clickable
                    required
                    v-model="dataParams.curriculumName"
                    label="课程名称"
                    class="select"
                    placeholder="请选择"
                    @click="showPickerView(2)"
                    :rules="[{ required: true, message: '课程名称不能为空!' }]"
            />
            <van-field
                    v-if="dataParams.disputeType !== '2'"
                    readonly
                    clickable
                    v-model="dataParams.signTime"
                    label="销课时间"
                    placeholder="请选择"
                    class="select"
                    @click="showPickerView(3)"
                    :rules="[{ required: true, message: '' }]"
            />
            <van-field name="picUrls" label="图片">
                <template #input>
                    <custom-upload ref="imgUpload" :value="dataParams.ideaUrls"/>
                </template>
            </van-field>

            <van-field name="videoUrls" label="视频">
                <template #input>
                    <video-upload ref="videoUpload" :value="dataParams.videoUrls"/>
                </template>
            </van-field>
            <van-field
                    v-model="dataParams.disputeDes"
                    label="说明"
                    type="textarea"
                    maxlength="255"
                    class="sm"
                    :rows="4"
                    placeholder="请输入"
            />
            <van-field/>
            <van-field/>
            <van-field/>
            <van-field/>

                <van-button round block type="info" native-type="submit" class="floatbox">提交</van-button>

        </van-form>
        <!-- 类型选择弹窗  -->
        <van-popup v-model="disputeTypeShow" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="disputeTypeOption"
                    @cancel="disputeTypeShow = false"
                    @confirm="(value, index) => onConfirm(value, index, 1)"
            />
        </van-popup>

        <!-- 课程选择弹窗  -->
        <van-popup v-model="curriculumShow" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="curriculumOption"
                    @cancel="curriculumShow = false"
                    @confirm="(value, index) => onConfirm(value, index, 2)"
            />
        </van-popup>

        <!-- 时间选择弹窗  -->
        <van-popup v-model="singTimeShow" position="bottom">
            <van-picker
                    show-toolbar
                    :columns="singTimeOption"
                    @cancel="singTimeShow = false"
                    @confirm="(value, index) => onConfirm(value, index, 3)"
            />
        </van-popup>
    </div>
</template>

<script>

    import {save,getCurriculumOption,getSignTimeOption} from '@/api/dispute/disputeInfo'
    import customUpload from '@/components/customUpload'
    import videoUpload from '@/components/videoUpload'

    export default {
        name: 'DisputeADD',
        components: {customUpload,videoUpload},
        data () {
            return {
                returnId: '',
                disputeTypeShow: false,
                curriculumShow: false,
                singTimeShow: false,
                curriculumOption: [],
                singTimeOption: [],
                disputeTypeOption: [{ text: "销课争议", key: '1' }, { text: "退费争议", key: '2' }, { text: "其他", key: '3' }],
                dataParams: {},
            }
        },
        computed: {
        },
        created () {
            this.returnId = this.$route.query.returnId;
            this.getCurriculumList()
        },
        mounted () {
            if (this.returnId) {
                this.dataParams.disputeType = "2";
                this.dataParams.disputeName = "退费争议"
            }
        },
        methods: {
            //typeL 1-纠纷类型 2-销课名称 3-销课时间
            showPickerView(type) {
                switch (type) {
                    case 1:
                        this.disputeTypeShow = true;
                        break;
                    case 2:
                        this.curriculumShow = true;
                        break;
                    case 3:
                        this.singTimeShow = true;
                        break;
                    default:
                }
            },
            onConfirm(value, index, type) {
                // console.log("数据参数", value, index, type);
                if (type === 1 && value) {
                    this.dataParams.disputeName = value.text;
                    this.dataParams.disputeType = value.key;
                    this.disputeTypeShow = false;
                    return;
                }
                if (type === 2 && value) {
                    this.dataParams.curriculumName = value.text;
                    this.dataParams.curriculumId = value.curriculumId;
                    this.dataParams.institutionId = value.institutionId;
                    this.dataParams.applyId = value.key;
                    this.curriculumShow = false;
                    this.getSignTimeList(this.dataParams.curriculumId, value.key);
                    return
                }
                if (type === 3 && value) {
                    this.dataParams.signTime = value.text;
                    this.dataParams.signDetailId = value.key;
                    this.singTimeShow = false;
                }
            },
            //获取课程数据
            getCurriculumList(){
                getCurriculumOption({ }).then(res => {
                    if (res.code === 10000) {
                        this.curriculumOption = res.result.map(item => {
                            item.text = item.label;
                            item.key = item.value;
                            return item
                        });
                        // console.log("sjaijs", this.curriculumOption)
                    }
                })
            },
            //销课时间数据
            getSignTimeList(curriculumId, applyId){
                this.dataParams.signTime = null;
                this.dataParams.signDetailId = null;
                if (!curriculumId || !applyId){
                    this.singTimeOption = [];
                    return
                }
                getSignTimeOption({curriculumId, applyId}).then(res => {
                    if (res.code === 10000) {
                        this.singTimeOption = res.result.map(item => {
                            item.text = item.label;
                            item.key = item.value;
                            return item
                        });
                    }
                })
            },
            onSubmit() {
                this.dataParams.applySide = "1";
                this.dataParams.picUrls = this.$refs.imgUpload.getUrls();
                this.dataParams.videoUrls = this.$refs.videoUpload.getUrls();
                if (this.returnId) {
                    this.dataParams.returnId = this.returnId
                }
                // console.log('submit', this.dataParams);
                save(this.dataParams).then(res => {
                    if (res.code === 10000) {
                        this.$toast("添加成功!");
                        setTimeout(() => {
                            this.$router.go(-1)
                        }, 200)
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.loading = false
                    }, 200)
                });
            },
            onClickLeft() {
                this.$router.go(-1)
            },
        }
    }
</script>

<style scoped>
/deep/.van-cell{
  padding:10px  15px;
}
/deep/.van-field__label{
  width:80px;
  font-size:14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
  box-sizing: border-box;
}
/deep/.select .van-field__value {
  height:35px;
  background: #F4F5F7;
  border-radius:100px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
/deep/.sm .van-field__value {
  height: 95px;
  background: #F4F5F7;
  border-radius:6px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  flex-direction: column;
}
/deep/.van-field__body{
  display: flex;
  width: 100%;
}
/deep/.sm .van-field__body{
  min-height:65px;
  align-items: flex-start;
  padding-top:5px;
  overflow-y: auto;
}
/deep/.van-field__word-limit{
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
/deep/.van-field__control{
  display: flex;
}
/deep/.van-cell::after{
  display: none;
}
/deep/.van-uploader__upload{
  width:116px;
  height:74px;
}
/deep/.van-uploader__preview-image{
  width:116px;
  height:74px;
}
</style>
